'use client';

export { default } from './useControlled';